import React, { useState, useRef } from "react";
import { login, sendEmail } from "../controllers/configuracionFirebase";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { anioAutor } from "../controllers/tiempoLimiteInscripcion";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Avatar } from "primereact/avatar";
import { datosAdmin } from "../controllers/administrador";
import toast from "react-hot-toast";
import { OverlayPanel } from "primereact/overlaypanel";

const Login = ({ setLogin, loginv, setDialogResultados }) => {

  const [contrasena, setContrasena] = useState('');

  const resetPasswordRef = useRef(null);

  /* la funcion clickLogin nos ayudara a pasar al otro formulario que es registrarse. */
  function clickLogin() {
    setLogin(false);
  }

  function enviarLinkResetPassword(email, link){
    const asunto = `🔒 Restablece tu contraseña de PROWEBSPORTS`
    const text = `
    <div style="font-family:Arial, sans-serif; text-align:center; background:#f6f9fc; padding:30px;">
      <div style="max-width:500px; margin:auto; background:white; border-radius:10px; padding:20px;">
        <img src="https://firebasestorage.googleapis.com/v0/b/prowebsports.appspot.com/o/img_logo_swimmingT.png?alt=media&token=26a9269b-3f2b-4336-9b34-8a9efaa054cf" alt="ProWebSports" style="width:150px; margin-bottom:20px;">

        <h2 style="color:#0066ff;">Restablece tu contraseña en PROWEBSPORTS</h2>
        <p style="color:#333;">Recibimos una solicitud para cambiar la contraseña de tu cuenta. Si fuiste tú, haz clic en el siguiente botón para crear una nueva contraseña:</p>

        <a href="${link}" style="display:inline-block; background:#0066ff; color:white; padding:12px 20px; border-radius:8px; text-decoration:none; margin-top:20px;">
          Cambiar contraseña
        </a>

        <p style="color:#333; margin-top:20px;">Si no solicitaste este cambio, puedes ignorar este mensaje. Tu contraseña actual seguirá siendo la misma.</p>

        <p style="color:#999; font-size:12px; margin-top:30px;">© PROWEBSPORTS — Alquilamos plataformas digitales para la administración de competencias de natación, incluyendo el uso de nuestro sistema semiautomático de cronometraje.</p>
      </div>
    </div>
    `;

    const toastId = toast.loading(`Enviando link de recuperación al correo ${email}`);
    sendEmail(asunto, text, [email, 'ebarbosa2499@gmail.com']).then(() =>{
      toast.dismiss(toastId);
      toast.success('Link enviado correctamente.');
    }).catch((err)=>{
      toast.dismiss(toastId);
      toast.success('¡UPS! Ocurrio un error. Intentalo de nuevo.');
    });
  }

  /* la funcion onSubmit traera todos los datos que se han ingresado en el login,
  y asi mismo validara si las credenciales son correctas o no. */
  function onSubmit(e) {
    e.preventDefault();

    const correo = e.target.email.value;
    const password = contrasena;
    login(correo, password);
    setContrasena('');
    e.target.reset();
  }

  /* la funcion onSubmitRestablecerPassword nos ayudara a traer el email, una vez con el email
  se le enviara un correo a ese email con un link donde podra restablecer la contraseña en caso de que se le haya
  olvidado.*/
  async function onSubmitRestablecerPassword(e) {
    e.preventDefault();

    const correo = e.target.email.value;
    const res = await fetch("https://linkresetpassword-6fbfrucvna-uc.a.run.app/linkResetPassword", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: correo, url: datosAdmin.plataforma }),
    });

    if(res.ok){
      const data = await res.json();
      enviarLinkResetPassword(correo, data.link);
      e.target.reset();
    }else{
      toast.error('No existe ninguna cuenta registrada con el correo electrónico ingresado.');
    }
  }

  return (
    <motion.div className="position-relative" style={{ top: '170px' }}
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ duration: 1, type: 'spring' }}
    >
      <img className="position-absolute top-0 start-50 translate-middle" style={{maxWidth: '535px', zIndex: 1, filter: "drop-shadow(0 -1px 2px black)"}} src={require('../img/img-deportistas.webp')} alt="imagen deportistas"/>
      <form
        onSubmit={onSubmit}
        className='position-relative w-100 p-3 shadow m-auto'
        style={{maxWidth: "400px", top: '28px', background: 'linear-gradient(110deg, rgba(250, 248, 156, 0.5), rgba(144, 222, 253, 0.5), rgba(253, 144, 144, 0.5))', borderRadius: '10px'}}
      >
        <Avatar className="mt-4 ms-3 position-absolute top-0 start-0" image={require('../img/img_logo.png')} size="large"/>
        <Avatar className="mt-4 me-3 position-absolute top-0 end-0" image={require('../img/img-logo-swimmingt.webp')} size="large"/>
        <Avatar className="mb-2 me-2 position-absolute bottom-0 end-0" image={require('../img/pwsmascota-derecha.png')} size="large"/>
        <div className="alert mb-0">
          <h1 className="mb-0" style={{fontFamily: 'Abril Fatface'}}>
            ¡BIENVENIDO!
          </h1>
          <hr className="my-1 mx-5"/>
          <p className="m-0" style={{fontFamily: 'Alkatra', textAlign: 'justify', lineHeight: 1.1}}>
            La experiencia deportiva de <strong>{datosAdmin.nombre}</strong> comienza aquí. Inicia sesión y forma parte de un evento organizado con pasión y profesionalismo.
          </p>
        </div>
        <div className="p-inputgroup flex-1 mb-1">
          <span className="p-inputgroup-addon submit">
              <i className="pi pi-at"></i>
          </span>
          <InputText type="email" name="email" placeholder="E-mail@example.com" required/>
        </div>
        <div className="p-inputgroup flex-1 mb-1">
          <span className="p-inputgroup-addon submit">
              <i className={contrasena.length >= 6 ? 'pi pi-unlock' : 'pi pi-lock'}></i>
          </span>
          <Password value={contrasena} onChange={(e) => setContrasena(e.target.value)} placeholder="Contraseña" toggleMask minLength={6} required
          feedback={false}/>
        </div>
        <div className="col-auto d-flex">
          <OverlayPanel ref={resetPasswordRef} style={{ width: '370px' }}>
            <div className="m-auto" style={{overflow: 'auto'}}>
              <form
                onSubmit={onSubmitRestablecerPassword}
                className="column g-3"
              >
                <input
                  type="email"
                  placeholder="email@example.com"
                  name="email"
                  className="form-control"
                  required
                />
                <Button
                  type="submit"
                  icon='pi pi-lock'
                  label="Enviar"
                  className="btn btn-primary w-100"
                />
              </form>
            </div>
          </OverlayPanel>
          <p className="mb-1">
            <button
              type="button"
              className="link text-primary"
              onClick={(e) => resetPasswordRef.current.toggle(e)}
            >
              ¿Has olvidado tu contraseña?
            </button>
          </p>
        </div>
        <div className="d-flex col-auto mb-1">
          <Button type="submit" icon='pi pi-key' label="ACCESO" className="m-1 btn btn-success w-100 paso1"></Button>
          <Button type="button" icon='pi pi-stopwatch' label="RESULTADOS" className="m-1 btn btn-primary w-100 paso2" onClick={() => setDialogResultados(true)}></Button>
        </div>
        <div className="col-auto">
          <p className="mb-0">
              No tienes una cuenta?{" "}
            <button type="button" className="link text-primary paso3" onClick={clickLogin}>   
              Inscribirse
            </button>
          </p>
        </div>
        <div className="prowebsports">
          <Link to='https://www.prowebsports.com.co' target="_blank" style={{fontSize: '12px', textDecoration: 'none'}}>© 2023 - {anioAutor()} prowebsports</Link>
        </div>
      </form>
    </motion.div>
  );
};

export default Login;